import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BaseComponent } from 'src/app/components/forms/base-form/base-form.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent extends BaseComponent {

  override successMessage: string = '';

  override onSubmit(f: NgForm) {
    let values = f.form.value;

    this.errorMessage = '';
    this.displayProgressSpinner(true);

    this._authRESTService.forgot_password(values.name)
      .subscribe(
        (data: any) => {
          this.displayProgressSpinner(false);
          this.successMessage = data?.message ?? 'If that account exists, password reset instructions have been sent to its email address.';
        },
        error => this.handleError(error)
      );
  }

}
